import React from 'react';
import { Dialog, Button, YStack, XStack } from 'tamagui';
import { CobuText, CobuStack } from '@cobu/ui';
import { Strings } from '../../constants/Strings';
import { useImagePicker } from '../../hooks/useImagePicker';

const strings = Strings.get();

interface ImagePickerModalProps {
  onClose: () => void;
  onImageSelected: (imageUrl: string, file: File) => void;
}

export default function ImagePickerModal({ 
  onClose,
  onImageSelected
}: ImagePickerModalProps) {
  const { handleChooseFromLibrary, handleTakePhoto } = useImagePicker({ 
    onImageSelected: (imageUrl, file) => {
      onImageSelected(imageUrl, file);
    }
  });

  const handleLibraryPress = () => {
    handleChooseFromLibrary();
    onClose();
  };

  const handleCameraPress = () => {
    handleTakePhoto();
    onClose();
  };

  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay
          key="overlay"
          opacity={0.5}
          bg="$black"
          onPress={onClose}
        />
        <Dialog.Content
          key="content"
          bordered
          elevate
          p="$0"
          gap="$0"
          maxWidth="90%"
          w="400px"
          br="$4"
          bg="$background"
        >
          <YStack>
            {/* Title */}
            <CobuStack ai="center" jc="center" py="$4" px="$4" bbc="$borderColor" bbw="$0.5">
              <CobuText variant="heading" fontSize="$5" fontWeight="600" color="$color">
                {strings.introduction.photoSection.actionSheetTitle}
              </CobuText>
            </CobuStack>

            {/* Action Buttons */}
            <CobuStack>
              <Button
                onPress={handleLibraryPress}
                unstyled
                h="$12"
                ai="center"
                jc="center"
                bbc="$borderColor"
                bbw="$0.5"
                bg="$background"
                hoverStyle={{ bg: '$backgroundHover' }}
                pressStyle={{ bg: '$backgroundPress' }}
              >
                <CobuText variant="body" fontSize="$4" color="$color">
                  {strings.introduction.photoSection.options.chooseFromLibrary}
                </CobuText>
              </Button>

              <Button
                onPress={handleCameraPress}
                unstyled
                h="$12"
                ai="center"
                jc="center"
                bbc="$borderColor"
                bbw="$0.5"
                bg="$background"
                hoverStyle={{ bg: '$backgroundHover' }}
                pressStyle={{ bg: '$backgroundPress' }}
              >
                <CobuText variant="body" fontSize="$4" color="$color">
                  {strings.introduction.photoSection.options.takePhoto}
                </CobuText>
              </Button>

              <Button
                onPress={onClose}
                unstyled
                h="$12"
                ai="center"
                jc="center"
                bg="$background"
                hoverStyle={{ bg: '$backgroundHover' }}
                pressStyle={{ bg: '$backgroundPress' }}
              >
                <CobuText variant="body" fontSize="$4" fontWeight="600">
                  {strings.introduction.photoSection.options.cancel}
                </CobuText>
              </Button>
            </CobuStack>
          </YStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
} 